export const LOAD_PLAN_PROGRESS = 'plan/LOAD_PLAN_PROGRESS';
export const SET_INTRODUCTION_DONE = 'plan/SET_INTRODUCTION_DONE';
